// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import SideMenuHOD from "../components/SideMenuHOD";
// import Header from "../components/Header";

// import mainPic from "../assets/images/Rectangle 626.png";
// import imgDocs from "../assets/images/Group 1000003697.png";
// import imgChart from "../assets/images/Frame 71.png";
// import API_BASE_URL from "../utilities/ApiConfig";

// const ValueRangeDeeds = () => {
//   const [reportType, setReportType] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [districts, setDistricts] = useState([]);
//   const [selectedDistrict, setSelectedDistrict] = useState("");
//   const [deedType, setDeedType] = useState("");
//   const [valueRangeOption, setValueRangeOption] = useState("");
//   const [range, setRange] = useState("");
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);

//   useEffect(() => {
//     const fetchDistricts = async () => {
//       const res = await axios.get(`${API_BASE_URL}/Master/get_District_Mas`);
//       setDistricts(res.data.data);
//     };
//     fetchDistricts();
//   }, []);

//   const handleDownload = () => {
//     console.log({
//       reportType,
//       fromDate,
//       toDate,
//       selectedDistrict,
//       deedType,
//       valueRangeOption,
//       range,
//     });
//   };

//   return (
//     <div className="flex h-screen overflow-hidden">
//       <SideMenuHOD
//         isOpen={isSidebarOpen}
//         onClose={() => setIsSidebarOpen(false)}
//       />

//       <div className="flex flex-col flex-1 overflow-y-auto bg-gray-50">
//         <Header onMenuToggle={() => setIsSidebarOpen((v) => !v)} />

//         <main className="p-4 md:p-8">
//           {/* Banner */}
//           <div className="mb-8">
//             <img
//               src={mainPic}
//               alt="Banner"
//               className="w-full h-40 md:h-56 object-cover rounded-lg shadow"
//             />
//           </div>

//           <div className="flex flex-col md:flex-row items-start md:items-center gap-8">
//             {/* Form */}
//             <div className="bg-white border border-gray-200 rounded-lg shadow p-6 w-full md:w-1/3">
//               <h2 className="text-xl font-semibold mb-6">Value Range Deeds</h2>
//               <div className="space-y-4">
//                 {/* FROM DATE */}
//                 <div className="relative">
//                   <input
//                     id="fromDate"
//                     type="date"
//                     required
//                     value={fromDate}
//                     onChange={(e) => setFromDate(e.target.value)}
//                     className="block w-full rounded border border-gray-300 bg-white py-3 px-3 text-base focus:outline-none focus:border-blue-500"
//                   />
//                   <label
//                     htmlFor="fromDate"
//                     className="absolute left-3 bg-white px-1 transition-all top-0 -translate-y-1/2 text-xs text-gray-700"
//                   >
//                     From Date
//                   </label>
//                 </div>

//                 {/* TO DATE */}
//                 <div className="relative">
//                   <input
//                     id="toDate"
//                     type="date"
//                     required
//                     value={toDate}
//                     onChange={(e) => setToDate(e.target.value)}
//                     className="block w-full rounded border border-gray-300 bg-white py-3 px-3 text-base focus:outline-none focus:border-blue-500"
//                   />
//                   <label
//                     htmlFor="toDate"
//                     className="absolute left-3 bg-white px-1 transition-all top-0 -translate-y-1/2 text-xs text-gray-700"
//                   >
//                     To Date
//                   </label>
//                 </div>

//                 {/* SELECT DISTRICT */}
//                 <div className="relative">
//                   <select
//                     id="district"
//                     required
//                     value={selectedDistrict}
//                     onChange={(e) => setSelectedDistrict(e.target.value)}
//                     className="block w-full rounded border border-gray-300 bg-white py-3 px-3 text-base appearance-none focus:outline-none focus:border-blue-500"
//                   >
//                     <option value="" disabled hidden>
//                       Select District
//                     </option>
//                     {districts.map((d) => (
//                       <option key={d.dcode} value={d.dcode}>
//                         {d.districtName}
//                       </option>
//                     ))}
//                   </select>
//                   <label
//                     htmlFor="district"
//                     className="absolute left-3 bg-white px-1 transition-all top-0 -translate-y-1/2 text-xs text-gray-700"
//                   >
//                     Select District
//                   </label>
//                 </div>

//                 {/* SELECT DEED */}
//                 <div className="relative">
//                   <select
//                     id="deedType"
//                     required
//                     value={deedType}
//                     onChange={(e) => setDeedType(e.target.value)}
//                     className="block w-full rounded border border-gray-300 bg-white py-3 px-3 text-base appearance-none focus:outline-none focus:border-blue-500"
//                   >
//                     <option value="" disabled hidden>
//                       Select Deed
//                     </option>
//                     <option value="deed1">Deed 1</option>
//                     <option value="deed2">Deed 2</option>
//                     {/* Add more deed options here */}
//                   </select>
//                   <label
//                     htmlFor="deedType"
//                     className="absolute left-3 bg-white px-1 transition-all top-0 -translate-y-1/2 text-xs text-gray-700"
//                   >
//                     Select Deed
//                   </label>
//                 </div>

//                 {/* VALUE RANGE */}
//                 <div className="relative">
//                   <select
//                     id="valueRangeOption"
//                     required
//                     value={valueRangeOption}
//                     onChange={(e) => setValueRangeOption(e.target.value)}
//                     className="block w-full rounded border border-gray-300 bg-white py-3 px-3 text-base appearance-none focus:outline-none focus:border-blue-500"
//                   >
//                     <option value="" disabled hidden>
//                       Value Range
//                     </option>
//                     <option value="0-100">0 - 100</option>
//                     <option value="100-500">100 - 500</option>
//                     {/* Add more ranges here */}
//                   </select>
//                   <label
//                     htmlFor="valueRangeOption"
//                     className="absolute left-3 bg-white px-1 transition-all top-0 -translate-y-1/2 text-xs text-gray-700"
//                   >
//                     Value Range
//                   </label>
//                 </div>

//                 {/* RANGE */}
//                 <div className="relative">
//                   <input
//                     id="range"
//                     type="text"
//                     required
//                     value={range}
//                     onChange={(e) => setRange(e.target.value)}
//                     className="block w-full rounded border border-gray-300 bg-white py-3 px-3 text-base focus:outline-none focus:border-blue-500"
//                   />
//                   <label
//                     htmlFor="range"
//                     className="absolute left-3 bg-white px-1 transition-all top-0 -translate-y-1/2 text-xs text-gray-700"
//                   >
//                     Range
//                   </label>
//                 </div>

//                 <button
//                   onClick={handleDownload}
//                   className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 rounded transition"
//                 >
//                   Download Report
//                 </button>
//               </div>
//             </div>

//             {/* Illustration + Text + Chart */}
//             <div className="flex flex-col md:flex-row items-start justify-start gap-4 md:gap-6 m-2">
//               <img
//                 src={imgDocs}
//                 alt="Documents Illustration"
//                 className="w-20 h-20 md:w-28 md:h-28"
//               />
//               <div className="flex flex-col max-w-md">
//                 <h3 className="text-2xl font-bold mb-2">
//                   Filter, Find, and Download in Seconds
//                 </h3>
//                 <div className="flex items-start gap-4">
//                   <p className="text-gray-600">
//                     Use smart filters and tags to download any report instantly
//                     — no matter how old or detailed.
//                   </p>
//                   <img
//                     src={imgChart}
//                     alt="Chart Icon"
//                     className="w-16 h-16 md:w-16 md:h-16"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </main>
//       </div>
//     </div>
//   );
// };

// export default ValueRangeDeeds;

import React, { useState, useEffect } from "react";
import axios from "axios";
import ReportLayout from "../components/ReportLayout";
import { DateField } from "../components/DateField";
import { SelectField } from "../components/SelectField";

import API_BASE_URL from "../utilities/ApiConfig";

export default function ValueRangeDeeds() {
  const [form, setForm] = useState({
    fromDate: "",
    toDate: "",
    district: "",
    deed: "",
    valueRange: "",
    range: "",
  });
  const [districts, setDistricts] = useState([]);
  const [deeds, setDeeds] = useState([]);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/Master/get_District_Mas`).then((res) => {
      setDistricts(res.data.data);
    });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/Registration/getDeedNames?mode=ALL`)
      .then((res) => {
        setDeeds(res.data);
      });
  }, []);

  const handleChange = (field) => (e) =>
    setForm((f) => ({ ...f, [field]: e.target.value }));
  const handleDownload = () => console.log(form);

  return (
    <ReportLayout title="Value Range Deeds" onDownload={handleDownload}>
      <DateField
        id="fromDate"
        label="From Date"
        value={form.fromDate}
        onChange={handleChange("fromDate")}
      />
      <DateField
        id="toDate"
        label="To Date"
        value={form.toDate}
        onChange={handleChange("toDate")}
      />
      <SelectField
        id="district"
        label="Select District"
        value={form.district}
        onChange={handleChange("district")}
        options={districts.map((d) => ({
          value: d.dcode,
          label: d.districtName,
        }))}
      />
      <SelectField
        id="deed"
        label="Select Deed"
        value={form.deed}
        onChange={handleChange("deed")}
        // options={[
        //   { value: "deed1", label: "Deed 1" },
        //   { value: "deed2", label: "Deed 2" },
        // ]}
        options={deeds.map((deed) => ({
          value: deed,
          label: deed,
        }))}
        disabled={deeds.length === 0}
      />
      <SelectField
        id="valueRange"
        label="Value Range"
        value={form.valueRange}
        onChange={handleChange("valueRange")}
        options={[
          { value: "0-100", label: "0 - 100" },
          { value: "100-500", label: "100 - 500" },
        ]}
      />
      <div className="relative">
        <input
          id="range"
          type="text"
          required
          value={form.range}
          onChange={handleChange("range")}
          className="block w-full rounded border border-gray-300 bg-white py-3 px-3 text-base focus:outline-none focus:border-blue-500"
        />
        <label
          htmlFor="range"
          className="absolute left-3 bg-white px-1 transition-all top-0 -translate-y-1/2 text-xs text-gray-700"
        >
          Range
        </label>
      </div>
    </ReportLayout>
  );
}
